import React, { FC, useEffect, useMemo } from 'react';
import { useParams } from 'react-router';

import { EvMainTitle } from '@evinced-private/ui-common';

import { ScanUrlsStatusView } from '../../pages/scan-analysis/views/urls-status-drilldown/ScanUrlsStatusViewV2';
import {
	INavigationRoute,
	useNavigation
} from '../../providers/navigationProvider/NavigationProvider';
import { IPropertyViewContext, usePropertyViewContext } from '../../providers/PropertyViewProvider';
import { EvPropertyViews } from '../common/ev-property-views/EvPropertyViews';
import { PropertyViewLoadErrorPage } from '../common/ev-property-views/PropertyViewLoadErrorPage';

import './DrilldownPage.scss';

const HEADER_TITLE = 'Scanned URLs Information';

export const UrlsStatusDrilldownPage: FC = () => {
	const { setCurrentRoute } = useNavigation();
	const { propertyId, scanId } = useParams<{ [key: string]: string }>();
	const propertyViewContext: IPropertyViewContext = usePropertyViewContext();
	const viewId = useMemo(() => propertyViewContext?.currentView?.id, [propertyViewContext]);
	const viewLoadErr = useMemo(() => propertyViewContext?.loadViewErr, [propertyViewContext]);

	const currentRoute: INavigationRoute = useMemo(() => {
		if (!propertyId || !scanId) {
			return null;
		}

		return {
			id: propertyId,
			title: HEADER_TITLE
		};
	}, [propertyId, scanId]);

	useEffect(() => {
		if (currentRoute) {
			setCurrentRoute(currentRoute);
		}
		return () => {
			setCurrentRoute(null);
		};
	}, [currentRoute, setCurrentRoute]);

	if (viewLoadErr) {
		return <PropertyViewLoadErrorPage propertyId={propertyId} />;
	}

	return (
		<div className="drilldown-page">
			<div className="drilldown-page-content">
				<div className="header">
					<EvMainTitle className="page-heading">{HEADER_TITLE}</EvMainTitle>
					<div className="filtered-views-controller">
						<EvPropertyViews propertyId={propertyId} />
					</div>
				</div>
				<ScanUrlsStatusView viewId={viewId} scanId={scanId} />
			</div>
		</div>
	);
};
